import React from 'react';
import { createPortal } from 'react-dom';
import { getDocumentIcon } from './seachpage-helpers';

export interface PreviewDoc { uri: string; extension: string; documentType?: string }
export function DocumentPreviewModal({ doc, onClose }: { doc: PreviewDoc | null; onClose: () => void }) {
  if (!doc) return null;
  let ext = (doc.extension || '').toLowerCase();
  if (!ext && doc.uri) {
    const m = doc.uri.match(/\.([a-zA-Z0-9]+)$/); ext = m?.[1]?.toLowerCase()||'';
  }
  if (ext.startsWith('.')) ext = ext.slice(1);
  const previewable = ['pdf','jpg','jpeg','png','gif'].includes(ext);

  const modal = (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={onClose}>
      <div style={{ background:'#fff', borderRadius:8, padding:10, minWidth:700, minHeight:500, maxWidth:'95vw', maxHeight:'95vh', position:'relative', boxShadow:'0 4px 10px rgba(0,0,0,0.2)' }} onClick={e=>e.stopPropagation()}>
        <button onClick={onClose} style={{ position:'absolute', top:12, right:12, background:'#eee', border:'none', borderRadius:4, padding:'4px 10px', cursor:'pointer', fontWeight:600 }}>Close</button>
        {previewable ? (
          ext==='pdf'
            ? <iframe src={doc.uri} style={{ width:'100%', height:'calc(80vh / var(--ui-scale))', border:'none' }} title="Preview"/>
            : <img src={doc.uri} alt="Preview" style={{ maxWidth:'100%', maxHeight:'calc(80vh / var(--ui-scale))', display:'block', margin:'0 auto' }} />
        ) : (
          <div style={{ padding:24, textAlign:'center' }}>Preview not available for: <b>{doc.documentType || ext || 'unknown'}</b></div>
        )}
      </div>
    </div>
  );

  // Render modal into document.body so it's outside the scaled app container and not affected by ui-scale transform
  return createPortal(modal, document.body);
}
